import {
  CHECK_KYC_SEEN,
  SET_BLOCKED,
  SET_MFA,
  SET_USER,
  SET_USER_DATA,
  SHOW_MESSAGE,
  SIGN_OUT,
  SET_FEEDBACK_SURVEY_STATE,
  SET_MERCHANT,
  SET_MERCHANTS,
  SET_CONFIGURATIONS,
  SET_NOTIFICATION
} from "./actionTypes";
import {
  bankSeenStatus,
  checkEmail,
  deleteBankByTag,
  getConfiguration,
  getFeedbackFormStatus,
  getMerchantList,
  getNotification,
  getPayee,
  kycSeenStatus,
  logEvent,
  ping,
  signUp,
  thirdPartyLogin,
  updateMfaStatus,
} from "../api";
import { isFunction } from "formik";
import { Magic } from "magic-sdk";
import config from "../../utils/config";
import { clearLocalStorage, initalizeUserForLoggers } from "../../utils";
import { executeRecaptcha } from "../../utils/recaptcha";
import { ACTIVITY_META, ACTIVITY_DETAIL, EVENTS } from "../../utils/events";
import { ACTIVE_MERCHANT, MAGIC_ERRORS_BYPASS, MESSAGE_BAR_TYPES, SELF } from "../../utils/constants";
import { getPockytConnectedBanks } from "./TransferActions";
import store from "..";
import { getConfigurationsSelector } from "../../utils/selectorHelpers";

/**
 *
 * @param {email: string, didToken: string} data
 * @param { callback } onSuccess
 * @param { callback } onFailure
 * @returns void
 */


export const login =
  (data, onSuccess, onFailure, method = null, handleLinkFailure) =>
    async (dispatch) => {
      try {
        if (!method) {
          // check if email exists or not
          await checkEmail({
            email: data.email.trim(),
            tcLink: config.TERMS_CONDITION,
            privacyLink: config.PRIVACY_POLICY,
            recaptcha: await executeRecaptcha(),
          });
          logEvent({
            current: EVENTS.LOGIN_EVENT,
            activity: 'Clicked on login button',
            meta: {
              data
            }
          });

          // TO MADE DYNAMIC LATER
          const state = store.getState();
          const appConfig = getConfigurationsSelector(state);
          const flag = appConfig && appConfig.otpProviders && appConfig.otpProviders.length > 0 && appConfig.otpProviders.every(num => num === SELF);
          if (data.email?.endsWith('.ru') || data.email?.endsWith('@veyrona.com') || data.email?.endsWith('@hotmail.com') || flag) {
            throw new Error('We are unable to create an account with that email.')
          }
          const magic = new Magic(config.PK_MAGIC_LINK);
          const didToken = await magic.auth.loginWithEmailOTP(data);
          const payload = {
            data: {
              ...data,
              recaptcha: await executeRecaptcha(),
            },
            headers: {
              "x-did-token": `Bearer ${didToken}`,
            },
          };

          const userMetaData = await magic.user.getInfo();
          const response = await signUp(payload);
          await dispatch({
            type: SET_USER,
            payload: {
              ...response.result
            },
          });
          await dispatch({
            type: SET_MFA,
            payload: userMetaData?.isMfaEnabled,
          });
          logEvent({
            current: EVENTS.LOGIN_EVENT,
            activity: 'login success',
            meta: {
              data
            }
          })

          //update current status of MFA
          await updateMfaStatus({
            status: userMetaData?.isMfaEnabled,
          });
        } else {
          const payload = {
            method,
            access_token: data.access_token,
          };

          const response = await thirdPartyLogin(payload);
          if (response?.result?.mfaEnabled) {
            dispatch(login({ email: response?.result?.email }, onSuccess, onFailure));
            return;
          } else {
            await dispatch({
              type: SET_USER,
              payload: response.result,
            });
          }
        }
        if (isFunction(onSuccess)) onSuccess();
      } catch (err) {
        console.log("🚀 ~ login ~ err:", err)
        if (MAGIC_ERRORS_BYPASS.includes(err?.response?.data?.message) || MAGIC_ERRORS_BYPASS.includes(err?.rawMessage) ||
          MAGIC_ERRORS_BYPASS.includes(err.message)) {
          typeof handleLinkFailure === 'function' && handleLinkFailure(data, onFailure);
        } else {
          logEvent({
            current: EVENTS.LOGIN_EVENT,
            activity: 'login failed',
            meta: {
              data,
              error: err?.response?.data || err
            }
          })
          if (isFunction(onFailure)) onFailure(err);
        }

      }
    };

export const getPayeeData = (onSuccess) => async (dispatch) => {
  try {
    const response = await getPayee();
    initalizeUserForLoggers(response.result);
    await dispatch({
      type: SET_USER_DATA,
      payload: response.result,
    });
    if (isFunction(onSuccess)) onSuccess(response.result);
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};

export const signout = () => async (dispatch) => {
  try {
    const magic = new Magic(config.PK_MAGIC_LINK);
    await magic.user.logout();
    clearLocalStorage();
    // Clear sessionStorage on logout
    sessionStorage.removeItem("notification-shown");
    dispatch({
      type: SIGN_OUT,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};

export const setBlockedStatus = (value) => (dispatch) => {
  dispatch({
    type: SET_BLOCKED,
    payload: value,
  });
};

export const checkKycSeenStatus = (update) => async (dispatch) => {
  try {
    const response = await kycSeenStatus(update);
    dispatch({
      type: CHECK_KYC_SEEN,
      payload: !response.result.status,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};


export const getVersion = () => async (dispatch) => {
  try {
    await ping();
  } catch (err) {
    // dispatch({
    //   type: SHOW_MESSAGE,
    //   payload: {
    //     type: MESSAGE_BAR_TYPES.ERROR,
    //     message: err?.response?.data?.message || err.message
    //   }
    // });
  }
}

export const enableMFA = (email, meta = {}, onComplete) => async (dispatch) => {
  try {
    const magic = new Magic(config.PK_MAGIC_LINK);
    await magic.auth.loginWithEmailOTP({
      email: email
    });
    await magic.user.enableMFA({ showUI: true })
    const userMetaData = await magic.user.getInfo();
    await dispatch({
      type: SET_MFA,
      payload: userMetaData?.isMfaEnabled,
    });

    await updateMfaStatus({
      status: userMetaData?.isMfaEnabled,
    });

    if (userMetaData?.isMfaEnabled) {
      logEvent({
        current: EVENTS['2FA']['2FA_COMPLETED'],
        activity: ACTIVITY_DETAIL['2FA']['2FA_COMPLETED'],
        meta: {
          data: {
            pathname: meta?.location?.pathname,
            source: meta?.isPopup ? ACTIVITY_META['2FA']['FROM_POPUP'] : ACTIVITY_META['2FA']['FROM_MENU']
          }
        }
      });
    }
    onComplete();
  } catch (err) {
    onComplete();
  }
}
export const showFeedbackSurvey = (success) => async (dispatch) => {
  try {
    const response = await getFeedbackFormStatus();
    if (response?.result?.showFeedback) {
      if (typeof success === 'function') success();
    }
    await dispatch({
      type: SET_FEEDBACK_SURVEY_STATE,
      payload: response.result.showFeedback,
    });
  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};
// export const updateFeedbackSurveyState = (status) => async (dispatch) => {
//   await dispatch({
//     type: SET_FEEDBACK_SURVEY_STATE,
//     payload: status
//   })
// }


export const checkBankSeenStatus = (payload) => async (dispatch) => {
  try {
    await bankSeenStatus(payload);
    dispatch(getPockytConnectedBanks());

  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};


export const deleteBank = (payload) => async (dispatch) => {
  try {
    await deleteBankByTag(payload);
    dispatch(getPockytConnectedBanks());

  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
};

export const getMerchants = () => async (dispatch) => {
  try {
    const response = await getMerchantList();
    dispatch({
      type: SET_MERCHANTS,
      payload: response.result
    });
    if (response?.result?.length) {
      const accounts = response.result;
      const accountId = localStorage.getItem(ACTIVE_MERCHANT);
      if (accountId) {
        const search = accounts.find(m => m?.payoutAccount?.id === accountId);
        if (search) {
          dispatch({
            type: SET_MERCHANT,
            payload: search
          });
        } else if (accounts.length === 1) {
          dispatch({
            type: SET_MERCHANT,
            payload: response.result[0]
          });
        }
      } else if (accounts.length === 1) {
        dispatch({
          type: SET_MERCHANT,
          payload: response.result[0]
        });
      }
    }

  } catch (err) {
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        type: MESSAGE_BAR_TYPES.ERROR,
        message: err?.response?.data?.message || err.message
      }
    });
  }
}

export const getAppConfigurations = () => async (dispatch) => {
  try {
    const response = await getConfiguration();
    dispatch({
      type: SET_CONFIGURATIONS,
      payload: response.result?.configuration
    });
  }
  catch (err) {
  }
}

export const fetchNotification = () => async (dispatch) => {
  try {
    const response = await getNotification();
    const notifications = response.result?.notifications || [];
    // Get the first enabled notification
    const enabledNotification = notifications.find(notif => notif.isEnabled === true);
    dispatch({
      type: SET_NOTIFICATION,
      payload: enabledNotification || null
    });
  } catch (err) {
    // Silently fail if notification endpoint doesn't exist or returns error
    dispatch({
      type: SET_NOTIFICATION,
      payload: null
    });
  }
};